import { ServerData } from '../../../typings'
import serverData from '../server-data'

const getError = (externalData: ServerData['external']) => {
  const error = {
    code: externalData.code,
    message: externalData.name,
    name: externalData.name,
    type: 'api',
    statusCode: 200,
  }

  switch (externalData.code) {
    case 'STEP_UP':
      return {
        data: {
          error: {
            ...error,
            pool: externalData.pool,
          },
        },
      }

    case 'STEP_UP_AUTHENTICATION_REQUIRED':
      return {
        data: {
          error: {
            ...error,
            redirectUrl: externalData.redirectUrl,
          },
        },
      }

    default:
      return null
  }
}

const getExternalData = () => {
  const externalData = serverData.external
  const code = externalData?.code
  const name = externalData?.name

  if (code && name) {
    // delete this so that it is only used once
    delete serverData.external

    return getError(externalData)
  }

  return null
}

export default getExternalData
